<template>
  <AuthTemplate>
    <h1>Создание нового пароля</h1>
    <form>
      <custom-input placeholder="Новый пароль" mb="20px"/>
      <button-component
        mb="10px"
        variant="filled"
        type="submit"
      >Подтвердить номер</button-component>
    </form>
  </AuthTemplate>
</template>

<script>
  import ButtonComponent from '../../../components/ui/buttons/button-component'
  import CustomInput from '../../../components/ui/inputs/custom-input'
  import AuthTemplate from '../../../templates/AuthTemplate'

  export default {
    name: 'NewPassword',
    components: {ButtonComponent,  CustomInput, AuthTemplate},
  }
</script>

<style scoped>

</style>